export const MUTATE_SEARCH_RESULT = 'MUTATE_SEARCH_RESULT';
export const EMPTY_SEARCH_RESULT = 'EMPTY_SEARCH_RESULT';
